import { KubernetesReadyData } from "../../components/detail/kubernetesReadinessReducer";
import { Mk8sCluster } from "../../schema/types/mk8s/entity/mk8s";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export const mk8sHelpers = {
  getProvider(mk8s: Mk8sCluster) {
    return Object.keys(mk8s.spec?.provider || {})[0];
  },
  getKubernetesVersion(mk8s: Mk8sCluster) {
    return mk8s.spec?.version;
  },
  getDashboardUrl(mk8s: Mk8sCluster) {
    return mk8s.status?.addOns?.dashboard?.url || "";
  },
  getHeadlampUrl(mk8s: Mk8sCluster) {
    return mk8s.status?.addOns?.headlamp?.url || "";
  },
  getIsAddonLogsEnabled(mk8s: Mk8sCluster) {
    return !!mk8s.spec?.addOns?.logs;
  },
};

export interface Mk8sClusterTableItem extends Mk8sCluster {
  selfLink: string;
  readiness?: KubernetesReadyData;
  provider: string;
  kubernetesVersion: string | undefined;
  dashboardUrl: string;
  headlampUrl: string;
  isAddonLogsEnabled: boolean;
}

interface GetMk8sClusterTableItemProps {
  link?: string;
  name?: string;
  item?: Mk8sCluster;
}
export function getMk8sClusterTableItem({ link, name, item }: GetMk8sClusterTableItemProps): Mk8sClusterTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;
    const provider = mk8sHelpers.getProvider(item);
    const kubernetesVersion = mk8sHelpers.getKubernetesVersion(item);
    const dashboardUrl = mk8sHelpers.getDashboardUrl(item);
    const headlampUrl = mk8sHelpers.getHeadlampUrl(item);
    const isAddonLogsEnabled = mk8sHelpers.getIsAddonLogsEnabled(item);

    return {
      ...item,
      selfLink: selfLink,
      // TODO fix or improve
      readiness: { ready: false },
      provider: provider,
      kubernetesVersion: kubernetesVersion,
      dashboardUrl: dashboardUrl,
      headlampUrl: headlampUrl,
      isAddonLogsEnabled: isAddonLogsEnabled,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "mk8s",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      dashboardUrl: "",
      headlampUrl: "",
      isAddonLogsEnabled: false,
      kubernetesVersion: "",
      provider: "",
      lastModified: "",
      tags: {},
      version: 1,
      spec: { provider: {}, version: "1.34.2" },
    };
  }

  // assume name
  return {
    kind: "mk8s",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    dashboardUrl: "",
    headlampUrl: "",
    isAddonLogsEnabled: false,
    kubernetesVersion: "",
    provider: "",
    lastModified: "",
    tags: {},
    version: 1,
    spec: { provider: {}, version: "1.34.2" },
  };
}
